import React, {useState} from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";
import Require from "../../../images/industries/healthcare-software/Requirement-Gathering.svg";
import Planning from "../../../images/industries/healthcare-software/Planning.svg";
import Testing from "../../../images/industries/healthcare-software/Deployment-Testing.svg";
import Integeration from "../../../images/industries/healthcare-software/Development-integeration.svg";
import Maintenance from "../../../images/industries/healthcare-software/Maintenance.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Industries(props) {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const getActiveClass = (index, className) =>
        toggleState === index ? className : "";

    return (
        <div className="seriveces_industries p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={12} xl={12} xxl={12}>
                        <div className="example" data-text="Process">
                            <h2>Our Healthcare Software Development Process</h2>
                        </div>
                        {/*<p className="strong">Your business has two practical options: be the first mover or follow the*/}
                            {/*existing models. Our custom software programs assist our partner clients in:</p>*/}
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="deskstop_version">
                        <div className="process_icons">
                            <ul>

                                <li className={`tabs ${getActiveClass(1, "active-tabs")}`}
                                    onClick={() => toggleTab(1)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Require}
                                            effect="blur" alt="Management" className="img-fluid"
                                        />
                                    </div>
                                    Requirement Gathering
                                </li>

                                <li className={`tabs ${getActiveClass(2, "active-tabs")}`}
                                    onClick={() => toggleTab(2)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Planning}
                                            effect="blur" alt="Retention" className="img-fluid"
                                        />
                                    </div>
                                    Planning and Design
                                </li>

                                <li className={`tabs ${getActiveClass(3, "active-tabs")}`}
                                    onClick={() => toggleTab(3)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Testing}
                                            effect="blur" alt="Engagement" className="img-fluid"
                                        />
                                    </div>
                                    Development and Testing
                                </li>
                                <li className={`tabs ${getActiveClass(4, "active-tabs")}`}
                                    onClick={() => toggleTab(4)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Integeration}
                                            effect="blur" alt="Frequency" className="img-fluid"
                                        />
                                    </div>
                                    Deployment and Integration
                                </li>
                                <li className={`tabs ${getActiveClass(5, "active-tabs")}`}
                                    onClick={() => toggleTab(5)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Maintenance}
                                            effect="blur" alt="Objective" className="img-fluid"
                                        />
                                    </div>
                                    Maintenance and Support
                                </li>

                            </ul>

                            <div className={toggleState === 1 ? 'content d-block' : "content d-none"}>
                                <p>Our software development process steps begin with detailed discussions about your needs, challenges, and goals.</p>
                            </div>
                            <div className={toggleState === 2 ? 'content d-block' : "content d-none"}>
                                <p>We create a comprehensive project plan and design a solution framework that aligns with the project’s requirements.</p>
                            </div>
                            <div className={toggleState === 3 ? 'content d-block' : "content d-none"}>
                                <p>Using industry best practices, we employ agile methodologies to ensure iterative development and feedback.</p>
                            </div>
                            <div className={toggleState === 4 ? 'content d-block' : "content d-none"}>
                                <p>We seamlessly ensure minimal disruption to your operations with a smooth deployment process, training, and support to adopt the software effectively.</p>
                            </div>
                            <div className={toggleState === 5 ? 'content d-block' : "content d-none"}>
                                <p>Our commitment is to ensure your healthcare software remains up-to-date, secure, and optimized for peak performance.</p>
                            </div>

                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="mobile_version">
                        <div className="tekrevol_mobile_accordion_side">
                            <Accordion
                                defaultActiveKey="1">

                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Require}
                                            effect="blur" alt="Management" className="img-fluid"
                                        />
                                        Requirement Gathering
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Our software development process steps begin with detailed discussions about your needs, challenges, and goals.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Planning}
                                            effect="blur" alt="Retention" className="img-fluid"
                                        />
                                        Planning and Design
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>We create a comprehensive project plan and design a solution framework that aligns with the project’s requirements.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Testing}
                                            effect="blur" alt="Engagement" className="img-fluid"
                                        />
                                        Development and Testing
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Using industry best practices, we employ agile methodologies to ensure iterative development and feedback.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Integeration}
                                            effect="blur" alt="Frequency" className="img-fluid"
                                        />
                                        Deployment and Integration
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>We seamlessly ensure minimal disruption to your operations with a smooth deployment process, training, and support to adopt the software effectively.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Maintenance}
                                            effect="blur" alt="Objective" className="img-fluid"
                                        />
                                        Maintenance and Support
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Our commitment is to ensure your healthcare software remains up-to-date, secure, and optimized for peak performance.</p>
                                    </Accordion.Body>
                                </Accordion.Item>

                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Industries;